export default __webpack_public_path__ + "media/images/zoom_in-6de18225e4ba025c3f13c6f7701ea2fd.png";